var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"0vh"},attrs:{"id":"app"}},[_c('v-app',[(_vm.$route.name !== 'The404Page')?_c('the-header'):_vm._e(),_c('v-main',[_c('router-view',{key:_vm.$route.fullPath})],1),(_vm.$route.name !== 'The404Page')?_c('the-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }